import React, { useState, useContext, useEffect, useRef } from 'react';
import { UserContext } from '../contexts/userContext';
import request from '../../services/Request';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../dashboard/components/ModernTable';
import { useTheme } from '@mui/material/styles';
import LoadingIcon from '../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import { userLimits } from '../dashboard/uitls/userLimits';
import { useHistory } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const getAllCateURL = `/machines/getFilteredCategroy/`;
const addCategoryToMachineURL = `/machines/updateCategory`;
const getMachineURL = `/machines/edit/`;

export default function AddCategoryToMachine(props) {
  const theme = useTheme();
  const { filterd } = useContext(UserContext);
  const history = useHistory();
  const { id, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    '',
    'edit_machine'
  );
  const machineID = props.match.params.id != 'all' ? props.match.params.id : null;

  const [allCates, setAllCates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [machine, setMachine] = useState(null);
  const [reflesh, setReflesh] = useState(false);
  const [title, setTitle] = useState('');
  const tableRef = useRef(null);

  useEffect(() => {
    // 检查 filterd 是否存在且不为空，如果为空则重定向到 viewMyMachines
    if (!machineID && (!filterd || filterd.length === 0)) {
      console.log('No machines selected, redirecting to viewMyMachines');
      history.push('/dashboard/viewMyMachines');
      return;
    }

    let machineURL1 = machineID ? machineID : filterd[0]._id;

    if (machineID) {
      const getMachine = async () => {
        await request({
          method: 'get',
          url: getMachineURL + machineURL1,
        }).then((res) => {
          setMachine(res.data);
        });
      };
      getMachine();
    } else {
      let string = '';
      if (filterd && filterd.length > 0) {
        filterd.forEach((e) => {
          string += e.name + ', ';
        });
        string = string.substring(0, string.length - 2);
      }
      setTitle(string);
    }

    const getCates = async () => {
      await request({
        method: 'get',
        url: getAllCateURL + machineURL1,
      }).then((res) => {
        let cate0 = res.data[0];
        let cate1 = res.data[1];

        cate0.forEach((e) => {
          e.name = e.name?.en;
        });

        cate1.forEach((e) => {
          e.name = e.name?.en;
        });

        const checkedCate = res.data[0];
        checkedCate.forEach((e) => (e.tableData = { checked: true }));
        const cate = res.data[0].concat(res.data[1]);

        setAllCates(cate);
        setLoading(true);
      });
    };
    getCates();

    return () => {
      setAllCates([]);
      setMachine(null);
    };
  }, [reflesh]);

  const addCategory = async (data) => {
    const cateIDs = data.length !== undefined ? data.map((cate) => cate._id) : [];
    await request({
      method: 'post',
      url: addCategoryToMachineURL,
      data: {
        machineID: machineID ? new Array(machineID) : (filterd?.map((e) => e._id) || []),
        ids: cateIDs,
      },
    }).then((res) => {
      Swal.fire({
        text: `The category has been successfully updated`,
        icon: 'success',
        target: document.getElementById('swal2-container'),
      });
      reflesh ? setReflesh(false) : setReflesh(true);
    });
  };

  const columns = [
    {
      title: 'Picture',
      field: 'categoryPicture',
      editable: 'never',
      render: (rowData) => (
        <img
          src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.categoryPicture}/${id}`}
          style={{
            width: 200,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
          }}
          alt={rowData.name}
        />
      ),
    },
    {
      title: 'Category Name',
      field: 'name',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CategoryIcon sx={{ fontSize: 20, color: theme.palette.primary.main }} />
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {rowData.name}
          </Typography>
        </Box>
      ),
    },
    {
      title: '',
      field: '',
      cellStyle: {
        width: '1px',
        padding: 0,
      },
      headerStyle: {
        width: '1px',
        padding: 0,
      },
      render: () => null,
    },
  ];

  // 如果没有机器ID且 filterd 为空，显示加载状态（等待重定向）
  if (!machineID && (!filterd || filterd.length === 0)) {
    return <LoadingIcon />;
  }

  return (
    <ModernPageContainer>
      <ModernPageHeader
        title="Update Categories"
        subtitle={
          machine
            ? `For Machine: ${machine.name}`
            : `For Machines: ${title}`
        }
        icon={CategoryIcon}
        buttons={[
          access && {
            text: 'Save Changes',
            icon: SaveIcon,
            onClick: () => {
              const selectedRows = tableRef.current?.dataManager?.data?.filter(row => row.tableData?.checked) || [];
              console.log('selectedRows from tableRef', selectedRows);
              addCategory(selectedRows);
            },
            variant: 'contained',
          },
          {
            text: 'Go Back',
            icon: ArrowBackIcon,
            onClick: () => history.goBack(),
            variant: 'outlined',
          },
        ].filter(Boolean)}
      />

      {!loading ? (
        <LoadingIcon />
      ) : (
        <Box sx={{ width: '100%' }}>
          <ModernTable
            tableRef={tableRef}
            columns={columns}
            data={allCates}
            title="Add Categories To the Machine"
            options={{
              actionsColumnIndex: -1,
              selection: true,
              pageSize: 10,
              pageSizeOptions: [5, 10, 20, 50],
              headerStyle: {
                textAlign: 'left',
              },
              cellStyle: {
                textAlign: 'left',
              },
            }}
          />
        </Box>
      )}
    </ModernPageContainer>
  );
}
